module.exports = __webpack_public_path__ + "static/img/5.ecf7690.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/sp/5.png
// module id = +7rP
// module chunks = 0